/* sb-dc-tplvideo.js - "Step & Repeat Video" button beside the search box on
   the design templates page. 2026-10-07.

   The gallery page is sections/sb-dc-templates.liquid, 84KB of markup, script
   and styles with the search box built inside it. Re-uploading that whole file
   to add one button is not worth the risk, so the button is added here and the
   section is left untouched. Taking this file out removes the button with it.

   Where it goes: #sbdt-searchwrap, the flex row that holds #sbdt-search and
   the result counter #sbdt-searchcount. The button is appended to that row and
   sits straight after them (store's request, 2026-10-07 - it was pushed to the
   far right first). The counter is empty until someone types, so at rest the
   button reads as being right beside the search field.

   Height is read off the search input at runtime rather than written down
   here: the input is styled inside that 84KB section, and a hard-coded 41px
   would drift the first time someone restyles it. The corner radius is the 6px
   the design center header button uses, not the input's 10px - this is a
   button, and it should match the other one the store already has.

   Same clip as the product page card (snippets/sb-dc-cta.liquid) and the
   design center header button (assets/sb-dc-tutvideo.js) - change the URL in
   all three if it is ever replaced. Nothing downloads until the customer
   clicks: preload is none and the src is only set when the lightbox opens.

   The gallery re-renders its grid as the customer filters, so placement is
   re-checked on a timer in case the row is rebuilt.

   2026-10-09 (theme "DC la"): the lightbox shows the video ONLY (store's
   request) - the black instructions panel above the clip is no longer added.
   buildText() and the wording are kept below, unused, so putting the panel
   back is one line in buildOv(). Same change in sb-dc-tutvideo.js and
   snippets/sb-dc-cta.liquid. */
(function () {
  'use strict';

  var BTN_ID = 'sbdt-vidbtn';
  var OV_ID = 'sbdt-vidov';
  var WRAP_ID = 'sbdt-searchwrap';
  var INPUT_ID = 'sbdt-search';
  var SELECT_ID = 'sbdt-product';
  var LABEL = 'Step & Repeat Video';   /* 2026-10-07: wording unified across all three */
  var ORANGE = '#FD913E';      /* the store's orange, read off Add to Cart */
  var NAVY = '#072747';        /* the header's own text colour */
  /* 2026-10-07: clip replaced (was 0407d58e...). The store's link ended ".mp4f";
     that 404s, ".mp4" is the file - 1920x1080, 33s. */
  var VIDEO_URL = 'https://cdn.shopify.com/videos/c/o/v/a855d7eb1015432d837f25563c657ab7.mp4';

  /* 2026-10-07: the lightbox carries the same instructions the design center
     one does (assets/sb-dc-tutvideo.js), word for word and styled the same -
     dark panel above the clip, orange label and heading, white body. A customer
     meets this clip in three places and should read the same thing each time;
     change the wording in all three together.
     2026-10-09: not shown any more (video only) - see the header note. */
  var CAP = 'Design it yourself in minutes';
  var HEAD = 'Making your own Step & Repeat is this easy';
  var BULLETS = [
    'Drop your logo into a ready-made pattern and watch it fill the entire ' +
      'backdrop instantly - no placing logos one by one.',
    'Slide the logos bigger, smaller, closer together, further apart. It is your call.',
    'Every change shows up live on screen, exactly as it will print.',
    'Free to use. No design skills, no extra charge.'
  ];

  /* ---- lightbox -------------------------------------------------------- */

  var ov = null, vid = null;

  function buildOv() {
    if (ov) return ov;
    ov = document.createElement('div');
    ov.id = OV_ID;
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-modal', 'true');
    ov.setAttribute('aria-label', LABEL);
    ov.style.cssText = 'position:fixed;inset:0;z-index:2147483000;display:none;' +
      'align-items:center;justify-content:center;background:rgba(0,0,0,.82);padding:24px';

    var inner = document.createElement('div');
    inner.style.cssText = 'position:relative;width:min(1000px,94vw);max-height:92vh;overflow:auto;' +
      'background:#000;border-radius:12px;box-shadow:0 20px 60px rgba(0,0,0,.5)';

    var x = document.createElement('button');
    x.type = 'button';
    x.setAttribute('aria-label', 'Close');
    x.innerHTML = '&times;';
    x.style.cssText = 'position:absolute;top:8px;right:10px;z-index:2;width:36px;height:36px;' +
      'border:0;border-radius:50%;background:rgba(0,0,0,.55);color:#fff;font-size:24px;' +
      'line-height:36px;cursor:pointer';
    x.addEventListener('click', hide);

    vid = document.createElement('video');
    vid.controls = true;
    vid.playsInline = true;
    vid.setAttribute('playsinline', '');
    vid.preload = 'none';
    /* 2026-10-09: back to 84vh - with the text panel gone the clip has the
       whole box to itself. */
    vid.style.cssText = 'display:block;width:100%;height:auto;max-height:84vh;background:#000';

    inner.appendChild(x);
    /* 2026-10-09: video only - inner.appendChild(buildText()) removed. */
    inner.appendChild(vid);
    ov.appendChild(inner);
    ov.addEventListener('click', function (e) { if (e.target === ov) hide(); });
    /* On <body>, outside the gallery, so a re-render cannot take it away
       while the clip is playing. */
    document.body.appendChild(ov);
    return ov;
  }

  /* The instructions, above the clip and inside the same rounded box. Black so
     it runs straight into the video rather than sitting on it as a white slab;
     orange for the label and heading, which hold up on black.
     2026-10-09: unused (video only). */
  function buildText() {
    var wrap = document.createElement('div');
    /* Padding-right clears the close button pinned to the top right. */
    wrap.style.cssText = 'background:#000;padding:16px 56px 16px 20px;' +
      'font:400 13px/1.45 Arial,Helvetica,sans-serif;color:#fff';

    var cap = document.createElement('div');
    cap.style.cssText = 'display:flex;align-items:center;gap:6px;margin:0 0 6px;' +
      'font-size:10.5px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;' +
      'color:' + ORANGE + ';line-height:1.3';
    var tri = document.createElement('span');
    tri.setAttribute('aria-hidden', 'true');
    tri.style.cssText = 'display:inline-block;width:0;height:0;border-style:solid;' +
      'border-width:4px 0 4px 7px;border-color:transparent transparent transparent ' + ORANGE;
    cap.appendChild(tri);
    cap.appendChild(document.createTextNode(CAP));

    var h = document.createElement('b');
    h.textContent = HEAD;
    /* Not bold (store's request) - it is a <b>, so say so explicitly. */
    h.style.cssText = 'display:block;font-size:13.5px;font-weight:400;line-height:1.3;color:' + ORANGE;

    var ul = document.createElement('ul');
    ul.style.cssText = 'margin:6px 0 0;padding:0 0 0 17px;list-style:disc';
    for (var i = 0; i < BULLETS.length; i++) {
      var li = document.createElement('li');
      li.textContent = BULLETS[i];
      li.style.cssText = 'margin:0 0 4px';
      ul.appendChild(li);
    }

    wrap.appendChild(cap);
    wrap.appendChild(h);
    wrap.appendChild(ul);
    return wrap;
  }

  function onKey(e) { if (e.key === 'Escape' || e.keyCode === 27) hide(); }

  function show() {
    buildOv();
    ov.style.display = 'flex';
    document.addEventListener('keydown', onKey);
    if (vid.getAttribute('src') !== VIDEO_URL) vid.setAttribute('src', VIDEO_URL);
    try { var p = vid.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {}
  }

  function hide() {
    if (!ov) return;
    ov.style.display = 'none';
    document.removeEventListener('keydown', onKey);
    try { vid.pause(); } catch (e) {}
    /* Drop the source so the CDN stream stops in the background. */
    vid.removeAttribute('src');
    try { vid.load(); } catch (e) {}
  }

  /* ---- which gallery gets the button ----------------------------------- */

  /* 2026-10-07 (3): the clip is about making a step & repeat, so the button
     belongs on that gallery only - it was showing on every product (store
     reported it on the flag galleries).

     Read off the page's own product dropdown (#sbdt-product) rather than the
     URL: the customer can change product in that dropdown without the address
     changing, and the gallery is one page serving every product. The option
     TEXT is matched, not its value - the values are a mix of list indexes ("5")
     and flag handles ("sbflag:teardrop-flag-small"), while the wording is what
     the gallery itself shows.

     Pop-Up Display Backdrop is included: the store's own ruling (2026-10-07)
     is that those are step & repeat, and the product pages and design center
     already treat them that way. Drop the second test here to make it stricter. */
  function wanted() {
    var sel = document.getElementById(SELECT_ID);
    if (!sel) return false;
    var opt = sel.options[sel.selectedIndex];
    var t = (opt ? opt.text : '').toLowerCase();
    if (!t) return false;
    if (t.indexOf('step') > -1 && t.indexOf('repeat') > -1) return true;
    if (t.indexOf('pop-up display backdrop') > -1) return true;
    return false;
  }

  /* ---- the button ------------------------------------------------------ */

  function place() {
    var wrap = document.getElementById(WRAP_ID);
    if (!wrap) return;

    var existing = document.getElementById(BTN_ID);

    /* Another product: take the button away again, and close the clip with it
       if it happens to be open. Checked every tick, so switching product in the
       dropdown adds or removes it without a page load. */
    if (!wanted()) {
      if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
      if (ov && ov.style.display === 'flex') hide();
      return;
    }

    if (existing) return;

    var input = document.getElementById(INPUT_ID);
    var h = '';
    if (input) h = window.getComputedStyle(input).height;  /* match the field */

    /* 2026-10-07 (2): built to match the design center header button (see
       assets/sb-dc-tutvideo.js) - filled with the store's orange, the header's
       navy for the words and the mark. Outlined-until-hover was tried first and
       the store wanted the solid one. */
    var b = document.createElement('button');
    b.type = 'button';
    b.id = BTN_ID;
    b.style.cssText = 'display:inline-flex;align-items:center;gap:7px;' +
      'flex:0 0 auto;padding:0 14px;' +
      (h ? 'height:' + h + ';' : 'padding-top:10px;padding-bottom:10px;') +
      'border:1px solid rgba(0,0,0,.06);border-radius:6px;' +
      'background:#FAD89D;color:' + NAVY + ';font-family:inherit;font-size:14px;' +   /* 2026-10-08: same warm yellow as the picked SR tab (owner); ORANGE stays for the lightbox caption */
      'font-weight:700;line-height:1;cursor:pointer;white-space:nowrap;' +
      'box-shadow:0 1px 3px rgba(0,0,0,.18);transition:filter .15s ease';

    /* The play mark inside a ring (store's request). An SVG rather than the
       CSS-border triangle used elsewhere: a circle around it needs a real
       shape, and both parts follow currentColor so they stay with the text. */
    var mark = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    mark.setAttribute('viewBox', '0 0 24 24');
    mark.setAttribute('width', '17');
    mark.setAttribute('height', '17');
    mark.setAttribute('aria-hidden', 'true');
    mark.style.cssText = 'flex:0 0 auto;display:block';
    mark.innerHTML =
      '<circle cx="12" cy="12" r="9.25" fill="none" stroke="currentColor" stroke-width="1.8"></circle>' +
      '<path d="M10 8.2l6 3.8-6 3.8z" fill="currentColor"></path>';
    b.appendChild(mark);
    b.appendChild(document.createTextNode(LABEL));

    b.addEventListener('mouseenter', function () { b.style.filter = 'brightness(.94)'; });
    b.addEventListener('mouseleave', function () { b.style.filter = ''; });
    b.addEventListener('click', function (e) { e.preventDefault(); show(); });

    wrap.appendChild(b);
  }

  function start() {
    place();
    /* The gallery rebuilds parts of the page as filters change; re-check so the
       button comes back if the row is replaced. */
    var t = setInterval(function () { try { place(); } catch (e) {} }, 500);
    window.addEventListener('pagehide', function () { clearInterval(t); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
